import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { Navbar } from "@/components/Navbar";
import { api } from "@/lib/api";

const when = (iso) => { try { return new Date(iso).toLocaleString(); } catch { return iso; } };

// Admin: bank transfers students say they've made. Confirm to unlock the course and email the student.
export default function AdminBankTransfers() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/bank-transfers").then(({ data }) => setRows(data.transfers)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const decide = async (id, status) => {
    if (status === "confirmed" && !window.confirm("Have you checked the money is in your bank account?")) return;
    try { await api.post(`/admin/bank-transfers/${id}`, { status }); toast.success(status === "confirmed" ? "Confirmed — the student has been emailed" : "Marked as not received"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not update"); }
  };
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="mx-auto max-w-4xl px-4 py-10">
        <Link to="/admin" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary" data-testid="bank-admin-back"><ArrowLeft size={14} /> Admin</Link>
        <h1 className="mt-4 font-serif text-4xl">Bank transfers</h1>
        <p className="mt-2 text-sm text-muted-foreground">Check each payment has arrived in your bank (match the reference), then confirm it to unlock the course.</p>
        {rows === null ? <p className="mt-6">Loading…</p> : !rows.length ? <p className="mt-6 text-muted-foreground" data-testid="bank-admin-empty">No bank transfers yet.</p> : (
          <div className="mt-6 space-y-3">
            {rows.map((t) => (
              <div key={t.id} className="rounded-2xl border border-border bg-card p-4" data-testid={`bank-admin-row-${t.id}`}>
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <p className="font-semibold">£{t.amount.toFixed(2)} · {t.item}</p>
                  <span className={`font-mono text-xs uppercase tracking-widest ${t.status === "pending" ? "text-primary" : "text-muted-foreground"}`} data-testid={`bank-admin-status-${t.id}`}>{t.status}</span>
                </div>
                <p className="mt-1 text-sm text-muted-foreground">{t.name} · {t.email} · Ref <b>{t.reference}</b> · {when(t.created_at)}</p>
                {t.note && <p className="mt-1 text-sm">“{t.note}”</p>}
                {t.status === "pending" && (
                  <div className="mt-3 flex gap-2">
                    <button onClick={() => decide(t.id, "confirmed")} data-testid={`bank-admin-confirm-${t.id}`} className="rounded-full bg-primary px-4 py-1.5 text-sm font-semibold text-primary-foreground">Confirm received</button>
                    <button onClick={() => decide(t.id, "rejected")} data-testid={`bank-admin-reject-${t.id}`} className="rounded-full border border-border px-4 py-1.5 text-sm">Not received</button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
